module.exports = __webpack_public_path__ + "assets/Social-itunes.259424b6.svg";